import {
  Paper,
  Typography,
  Button,
  Divider,
  Autocomplete,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Switch,
  CircularProgress,
  TablePagination,
  Avatar,
  Tooltip,
} from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import {
  ChangeEvent,
  SyntheticEvent,
  useContext,
  useRef,
  useState,
} from "react";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import EditIcon from "@mui/icons-material/Edit";
import debounce from "../../../utilis/methods/networkHandling";
import { MasterTableDataType, SearchParamsType, TimeSlotType } from "./types";
import {
  deleteDoctor,
  getAllDoctor,
  getTimeSlots,
  updateDoctorStatus,
} from "./services";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "../../../routes/moduleRouteList";
import generalMasterRouteList from "../routeList";
import mastersRouteList from "../../routeList";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import TimeSlotes from "./TimeSlotes";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import DoctorMasterDataProvider, {
  DoctorMasterDataContext,
} from "./context/DoctorMasterDataProvider";
const base = (window as any)._env_?.BASE_URL;
const pageTitle = "Doctors";

const DoctorsList = () => {
  const navigate = useNavigate();
  const { setTimeSlots } = useContext(DoctorMasterDataContext);
  const [searchParams, setSearchParams] = useState<SearchParamsType>({
    filter: { search: "", status: 2 },
    pageSize: 25,
    pageNumber: 0,
  });

  const { CustomModal, showSnackbar } = usePopup();
  const [selected, setSelected] = useState<number[]>([]);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [openTime, setOpenTime] = useState<boolean>(false);
  const [timeSlotId, setTimeSlotId] = useState<number | null>(null);
  // const [tableData,setTableData] = useState<MasterTableDataType[]>([])
  const indexRef = useRef<number | null>(null);
  const {
    data: resultTableData,
    isFetching: tableDataLoading,
    refetch,
  } = useQuery(
    ["doctorMasterTableData", searchParams],
    async () =>
      await getAllDoctor({
        ...searchParams,
        filter: {
          ...searchParams.filter,
          status:
            searchParams.filter.status == 2 ? null : searchParams.filter.status,
        },
      }),
    {
      refetchOnWindowFocus: false,
      enabled: true,
    }
  );
  const { isLoading: timeSlotLoading } = useQuery(
    ["allDoctorTimeSlot", timeSlotId],
    async () => await getTimeSlots(timeSlotId as number),
    {
      enabled: Boolean(timeSlotId),
      refetchOnWindowFocus: false,
      onSuccess: (result) => {
        if (result?.response?.items?.length) {
          const update: { [key: number]: TimeSlotType } = {};
          result?.response?.items.forEach((day) => {
            update[day.dayId] = day;
          });
          setTimeSlots(update);
        }
      },
    }
  );

  const { mutate: deleteSelected, isLoading: deleteLoading } = useMutation(
    deleteDoctor,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          refetch();
          setSelected([]);
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 3000,
          });
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.errorMessage ||
            e?.response?.data?.responseMessage ||
            "Something went wrong !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    }
  );

  const { mutate: updateStatus, isLoading: updateLoading } = useMutation(
    updateDoctorStatus,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          refetch();
          // const update = [...tableData]
          // update[indexRef.current as number].status = update[indexRef.current as number].status ? 0 : 1
          // setTableData(update)
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 3000,
          });
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.errorMessage ||
            e?.response?.data?.responseMessage ||
            "Something went wrong !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    }
  );

  const handleStatusChange = (
    _: SyntheticEvent,
    option: { label: string; value: number }
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      filter: { ...prev.filter, status: option.value },
    }));
  };
  const handleOpenDeleteWarning = (item: MasterTableDataType) => {
    setSelected([item.id]);
  };

  const handleNavigateClick = (data?: MasterTableDataType) => {
    navigate(
      `${base}${moduleRoutes.mainRoute}/${moduleRoutes.masters}/${mastersRouteList.generalMaster}/${generalMasterRouteList.doctorMaster}/${generalMasterRouteList.addOrEdit}`,
      { state: { data: data || null } }
    );
  };

  const handleOpenTimeSlot = (data?: MasterTableDataType) => {
    setOpenTime(true);
    setTimeSlotId(data?.id as number);
    navigate(".", { state: { data: data || null } });
  };

  const handleUpdateOneStatus = (
    isChecked: boolean,
    item: MasterTableDataType & { index: number }
  ) => {
    setSelectedId(item.id);
    indexRef.current = item.index;
    updateStatus({
      id: item.id as number,
      status: isChecked ? 1 : 0,
    });
  };

  const handleDelete = () => {
    deleteSelected({ ids: selected });
  };
  const handleCloseDelete = () => {
    setSelected([]);
  };

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchParams((prev) => ({
      ...prev,
      filter: { ...prev.filter, search: e.target.value },
    }));
  };

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    pageNumber: number
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNumber: 0,
      pageSize: parseInt(event.target.value, 10),
    }));
  };
  const debounceSearch = debounce(handleSearchChange, 500);

  const handleTimeSlotClose = () => {
    setOpenTime(false)
    refetch()
  };

  return (
    <div className="px-2 py-3">
      <CustomModal
        title="Time slot"
        open={openTime}
        setOpen={setOpenTime}
        handleClose={handleTimeSlotClose}
      >
        <div className="w-[80vw]">
          {timeSlotLoading ? (
            <div className="p-5">
              <Typography>
                Fetching details <CircularProgress size={20} />
              </Typography>
            </div>
          ) : (
            <TimeSlotes />
          )}
        </div>
      </CustomModal>
      <CustomModal
        title={"Delete doctor"}
        open={Boolean(selected.length) || deleteLoading}
        handleClose={handleCloseDelete}
        setOpen={() => {}}
      >
        <div className="px-3 py-4 w-[20vw]">
          <div className="py-3">
            <Typography>Are you sure want to delete the doctor !</Typography>
          </div>
          <div className="pt-2 flex justify-end items-center gap-2">
            <Button variant="text" color="success" onClick={handleCloseDelete}>
              no
            </Button>
            <Button
              variant="text"
              disabled={deleteLoading}
              color="error"
              onClick={handleDelete}
              endIcon={
                deleteLoading && <CircularProgress color="error" size={18} />
              }
            >
              yes
            </Button>
          </div>
        </div>
      </CustomModal>
      <Paper>
        <div className="flex justify-between p-3">
          <div className="flex gap-2">
            <Typography variant="h6" color={"default"}>
              {pageTitle} Master
            </Typography>
          </div>
          <div className="flex gap-2">
            <Button
              onClick={() => {
                handleNavigateClick();
              }}
            >
              new {pageTitle}
            </Button>
          </div>
        </div>
        <Divider />
        <div className="">
          <div className="grid grid-cols-4 gap-3 py-3 px-2">
            <Autocomplete
              disableClearable
              fullWidth
              defaultValue={
                selectedStatus[
                  searchParams.filter.status as keyof typeof selectedStatus
                ]
              }
              options={statusOptions}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              renderInput={(params) => <TextField {...params} label="Status" />}
              onChange={handleStatusChange}
            />
            <TextField label={"Search"} onChange={debounceSearch} />
            <div></div>
            {tableDataLoading && (
              <div className="flex justify-end gap-2 items-center">
                {" "}
                <Typography>Loading </Typography> <CircularProgress size={18} />
              </div>
            )}
          </div>
          <TableContainer className="border">
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                    <Checkbox
                      checked={
                        selectedSize == tableData?.response?.items?.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell> */}
                  <TableCell></TableCell>
                  {headings.map((heading) => (
                    <TableCell key={heading.key} className="font-bold">
                      {heading.label}
                    </TableCell>
                  ))}
                  <TableCell className="font-bold">Status</TableCell>
                  <TableCell className="font-bold">Actions</TableCell>
                </TableRow>
              </TableHead>
              <CustomTableBody
                alert={"No data"}
                dataLoading={tableDataLoading}
                isData={Boolean(resultTableData?.response?.items?.length)}
                totalSpan={{
                  row: searchParams.pageSize,
                  col: headings.length + 3,
                }}
              >
                {resultTableData?.response?.items?.map((tableItem, index) => (
                  <TableRow key={`${pageTitle}-${index}`}>
                    {/* <TableCell>
                      <Checkbox
                        checked={Boolean(selected[index])}
                        onChange={(e) => {
                          handleSelect(e.target.checked, tableItem, index);
                        }}
                      />
                    </TableCell> */}
                    <TableCell>
                      <Avatar src={tableItem?.photo || ""} />
                    </TableCell>
                    {headings.map((heading) => (
                      <TableCell>
                        {tableItem[heading.key as keyof typeof tableItem]}
                      </TableCell>
                    ))}
                    <TableCell>
                      {tableItem.status == 1 ? (
                        <div className="text-green-600  rounded-[10px] w-[70px] font-semibold">
                          Active
                        </div>
                      ) : (
                        <div className="text-red-600 rounded-[10px] w-[70px] font-semibold">
                          Inactive
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      <div className="flex gap-2">
                        <Tooltip title="Edit doctor">
                          <IconButton
                            color="primary"
                            onClick={() => {
                              handleNavigateClick(tableItem);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        {Boolean(tableItem.isTimeSlot) ? (
                          <Tooltip title="Update time slots">
                            <IconButton
                              color="success"
                              onClick={() => {
                                handleOpenTimeSlot(tableItem);
                              }}
                            >
                              <MoreTimeIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Add time slots">
                            <IconButton
                              color="warning"
                              onClick={() => {
                                handleOpenTimeSlot(tableItem);
                              }}
                            >
                              <RunningWithErrorsIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        <Tooltip title="Delete doctor">
                          <IconButton
                            color="error"
                            onClick={() => {
                              handleOpenDeleteWarning(tableItem);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                        <div className="flex justify-center items-center gap-2">
                          <Switch
                            checked={Boolean(tableItem.status)}
                            disabled={
                              (updateLoading || tableDataLoading) &&
                              tableItem.id == selectedId
                            }
                            onChange={(e) => {
                              handleUpdateOneStatus(e.target.checked, {
                                ...tableItem,
                                index,
                              });
                            }}
                          />
                          {(updateLoading || tableDataLoading) &&
                            tableItem.id == selectedId && (
                              <CircularProgress size={18} />
                            )}
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </CustomTableBody>
            </Table>
            <div className="flex justify-end">
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component={"div"}
                count={resultTableData?.response?.totalCount || 0}
                rowsPerPage={searchParams.pageSize}
                page={searchParams.pageNumber}
                sx={{ border: 0 }}
                slotProps={{
                  select: {
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                // ActionsComponent={TablePaginationActions}
              />
            </div>
          </TableContainer>
        </div>
      </Paper>
    </div>
  );
};

const DoctorsMaster = () => {
  return (
    <DoctorMasterDataProvider>
      <DoctorsList />
    </DoctorMasterDataProvider>
  );
};

export default DoctorsMaster;
const headings = [
  {
    label: "Code",
    key: "code",
  },
  {
    label: "License no",
    key: "licenceNumber",
  },
  {
    label: "Name",
    key: "name",
  },
  {
    label: "Department",
    key: "deptName",
  },
  {
    label: "C.C.E.P",
    key: "ccep",
  },
];
const statusOptions = [
  { label: "All", value: 2 },
  { label: "Active", value: 1 },
  { label: "Inactive", value: 0 },
];
// const status = [
//   { label: "Active", value: 1 },
//   { label: "Inactive", value: 0 },
// ];
const selectedStatus = {
  2: { label: "All", value: 2 },
  1: { label: "Active", value: 1 },
  0: { label: "Inactive", value: 0 },
};
